<template>
    <section class="hero">
        <div class="hero-body">
            <p class="title">
                Quick Search
            </p>
            <BeneficiarySearch />
        </div>
    </section>

    <section class="hero is-light">
        <div class="hero-body">
            <p class="title">
                Advanced Search
            </p>
            <div class="align-center">
                <router-link to="/beneficiary/advancedsearch">
                    <button class="button is-info is-rounded align-center">Start searching</button>
                </router-link>
            </div>
        </div>
    </section>

    <section class="hero">
        <div class="hero-body">
            <p class="title">
                Create
            </p>
            <CreateBeneficiary />
        </div>
    </section>
</template>

<script>
import BeneficiarySearch from '@/components/beneficiary/BeneficiarySearch.vue';
import CreateBeneficiary from '@/components/beneficiary/CreateBeneficiary.vue';

export default {
    components: {
        BeneficiarySearch,
        CreateBeneficiary
    }
};
</script>

<style scoped>
.hero-body {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 20px;
    padding-top: 20px;
}
</style>